function injectStyle (ssrContext) {
  require("!!../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2ed7d734\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./examinationItem.vue")
}
var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./examinationItem.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2ed7d734\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./examinationItem.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ed7d734",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/modules/remote-edu/examination-item/examinationItem.vue
// module id = 91bf012d999b0475d7d9
// module chunks = 3